"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X, Search } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="group relative px-4 py-2 text-sm font-medium text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:!bg-transparent focus:!bg-transparent hover:text-primary focus:text-primary">
                  {item.label}
                  <span className="absolute bottom-0 left-1/2 h-0.5 w-0 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full group-hover:left-0 group-focus:w-full group-focus:left-0" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b shadow-medium md:hidden">
          <nav className="container mx-auto px-4 py-4">
            <ul className="flex flex-col gap-2">
              {menuItems.map((item, i) => <li key={item.id} data-index={i}>
                  <Link to={item.href || "#"} className="block px-4 py-2 text-sm font-medium text-foreground rounded-md hover:bg-accent hover:text-accent-foreground transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Encabezado() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-background transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isScrolled ? "h-14 shadow-soft" : "h-16"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between gap-4">
        {}
        <Link to="/" className="flex-shrink-0">
          <img src="https://vokseglobalconsulting.com/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-12-at-21.06.45.jpeg" alt="Vokse Global Consulting" className="h-12 !rounded-none !opacity-[1]" />
        </Link>

        {}
        <div className="hidden md:flex items-center gap-6 flex-1 justify-end">
          <MenuProvider menu_id="4">
            <HeaderMenuConsumer />
          </MenuProvider>

          {}
          <div className="relative">
            {searchOpen ? <div className="flex items-center gap-2">
                <Input type="search" placeholder="Buscar..." className="w-48 h-9" autoFocus onBlur={() => setSearchOpen(false)} />
              </div> : <Button variant="ghost" size="icon" className="hover:!bg-transparent focus:!bg-transparent" onClick={() => setSearchOpen(true)} aria-label="Search">
                <Search className="size-4" />
              </Button>}
          </div>

          {}
          <Button asChild className="hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:!bg-primary-hover focus:!bg-primary-active hover:!text-white focus:!text-white">
            <Link to="/ContactPage">Contactar</Link>
          </Button>
        </div>

        {}
        <div className="flex md:hidden items-center gap-2">
          <Button variant="ghost" size="icon" className="hover:!bg-transparent focus:!bg-transparent" onClick={() => setSearchOpen(!searchOpen)} aria-label="Search">
            <Search className="size-4" />
          </Button>

          <MenuProvider menu_id="4">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        {}
        {searchOpen && <div className="absolute top-full left-0 right-0 bg-background border-b shadow-medium p-4 md:hidden">
            <Input type="search" placeholder="Buscar..." className="w-full" autoFocus onBlur={() => setSearchOpen(false)} />
          </div>}
      </div>
    </header>;
}